module.exports = __webpack_public_path__ + "static/media/31JFA12.0b132676.jpg";